import React, { useState } from "react";
import { Close, InfoOutlined } from "@mui/icons-material";
import s from "./NoticeBox.module.scss";
import TextMAS from "components/TextMAS/TextMAS";

const NoticeBox = ({ title, children, showClose }) => {
  const [showNotification, setShowNotification] = useState(true);

  return (
    <>
      {showNotification && (
        <div className={s.notificationOuterContainer}>
          <div className={s.notificationInnerContainer}>
            <div className={s.notificationIconContainer}>
              <InfoOutlined style={{ color: "#1B595F", fontSize: "20px" }} />
            </div>
            <div className={s.notificationContentContainer}>
              <div className={s.notificationTitleContainer}>
                {
                  title && <TextMAS>{(title) + ":"}</TextMAS>
                }
                {showClose && (
                  <div
                    className={s.notificationCloseContainer}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowNotification(false);
                    }}
                  >
                    <Close style={{ fontSize: "15px" }} />
                  </div>
                )}
              </div>
              <div className={s.notificationText}>{children}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NoticeBox;
